import axios from "axios";

const API_DESPACHO = import.meta.env.VITE_API_DESPACHO;
const GarrisonTimelineService = {
  apply: async (payload) => axios.post(API_DESPACHO + "/garrison-timeline/apply", payload).then(({ data }) => data).catch((err) => { throw err }),
  apply2: async (payload) => axios.post(API_DESPACHO + "/garrison-timeline/apply2", payload).then(({ data }) => data).catch((err) => { throw err }),
  print: async (payload) => axios.post(API_DESPACHO + "/garrison-timeline/print", payload).then(({ data }) => data).catch((err) => { throw err }),
  snapshot: async (payload) => axios.post(API_DESPACHO + "/garrison-timeline/snapshot", payload).then(({ data }) => data).catch((err) => { throw err }),
  routes: async (payload) => axios.post(API_DESPACHO + "/garrison-timeline/routes", payload).then(({ data }) => data).catch((err) => { throw err }),
}

export default GarrisonTimelineService;
